import { useEffect, useMemo, useState } from 'react';
import { FormikProps } from 'formik';
import { getCoreRowModel } from '@tanstack/react-table';

// MUI Theme
import { Paper } from '@mui/material';

// Utils
import { makeManageLanguagelabelsColumn } from '../../../../utils/columns/makeManageLanguagelabelsColumn';

// Services
import { getLanguage } from '../../../../services/language.services';

// Types
import { TranslationItem } from '../../../../types/Language';
import { useStandardTable as useTable, Table } from '../../../common/table/index';

interface EditLanguageLabelProps {
  formRef: FormikProps<TranslationItem>;
  handleDelete: (isoCode: string, label: string) => void;
  handleEdit: (language: TranslationItem) => void;
  refresh: boolean;
}
const UpdateLanguage = (props: EditLanguageLabelProps) => {
  const [languageData, setLanguage] = useState<any>([]);

  const columns = useMemo(
    () => makeManageLanguagelabelsColumn(props.handleEdit, props.handleDelete, props.formRef.values.isoCode ?? ''),
    [props.formRef.values.isoCode]
  );

  const fetchLanguage = async () => {
    const response: any = await getLanguage(props.formRef.values.isoCode ?? '');
    if (response.status === 200) {
      const langData = Object.keys(response.data).map((keyName) => {
        return {
          name: keyName,
          value: response.data[keyName],
        };
      });
      setLanguage(langData);
    }
  };

  useEffect(() => {
    if (props.formRef.values.isoCode) {
      fetchLanguage();
    }
  }, [props.formRef.values.isoCode, props.refresh]);

  const table = useTable<any>({
    columns,
    serverSide: true,
  });

  return (
    <>
      <Paper>
        <Table
          {...table}
          data={languageData}
          showAction={false}
          showSearchBar={false}
          showColumnToggler={false}
          showPagination={false}
          getCoreRowModel={getCoreRowModel()}
        />
      </Paper>
    </>
  );
};

export default UpdateLanguage;
